import type { User } from '../types'

/** Může podat žádost (FKSP, dovolená, …) jménem jiného zaměstnance. */
export function canCreateOnBehalf(user: Pick<User, 'role' | 'admin_type'> | null | undefined): boolean {
  if (!user?.role) return false
  if (user.role === 'financist' || user.role === 'referent_eko') return true
  if (user.role === 'admin' && (user.admin_type === 'spravce_it' || user.admin_type === 'spravce_budov')) {
    return true
  }
  if (['vedouci', 'vedouci_executor', 'zastupce_reditele'].includes(user.role)) return true
  if (user.role === 'spravce_jidelny') return true
  return false
}

/** Smazat žádost: vlastní, podanou za jiného, nebo IT admin. */
export function canDeleteOnBehalfRequest(
  user: Pick<User, 'id'> | null | undefined,
  req: { requester_id?: string | null; created_by_id?: string | null },
  isItAdmin = false,
): boolean {
  if (!user?.id) return false
  if (isItAdmin) return true
  if (String(req.requester_id ?? '') === String(user.id)) return true
  const createdBy = req.created_by_id
  return createdBy != null && String(createdBy).trim() !== '' && String(createdBy) === String(user.id)
}
